import React from "react";
import PresList from "./PresList";

const ListModal = ({ children, showList, setShowList, add }) => {
  if (showList) {
    return (
      <>
        <div className=" h-screen flex overflow-x-clip overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative w-fit mx-auto">
            <div className="border-0  shadow-lg relative flex flex-col w-full items-end  outline-none focus:outline-none">
              <div className="relative w-screen    flex-auto h-screen">
                <PresList setShowList={setShowList} add={add}>
                  {children}
                </PresList>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    );
  }
  return null;
};

export default ListModal;
